import { useTranslation } from 'react-i18next';
import { Maximize, Minimize } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';
import { useFullscreen } from './fullscreen';

/**
 * In and out of full screen, one tap (`fullscreen.ts`). In the top bar, and in the
 * header of «Operar», which has no top bar. Not drawn where the browser cannot do it,
 * nor in the installed app (no browser bars to hide).
 */
export function FullscreenButton({
  className,
  iconClassName,
}: {
  className?: string;
  iconClassName?: string;
}) {
  const { t } = useTranslation();
  const { supported, active, toggle } = useFullscreen();
  if (!supported) return null;
  const label = t(active ? 'fullscreen.exit' : 'fullscreen.enter');
  const Icon = active ? Minimize : Maximize;
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('h-9 w-9', className)}
      aria-label={label}
      title={label}
      data-testid="fullscreen-toggle"
      data-active={active}
      onClick={toggle}
    >
      <Icon className={cn('h-4 w-4', iconClassName)} aria-hidden />
    </Button>
  );
}
